import React from 'react';
import { VariableValidationResult } from '../utils/variables';

interface VariableValidationAlertsProps {
  validation: VariableValidationResult;
  compact?: boolean;
}

export const VariableValidationAlerts: React.FC<VariableValidationAlertsProps> = ({
  validation,
  compact = false,
}) => {
  const { undefinedVars, unusedVars, invalidSyntax } = validation;
  if (
    undefinedVars.length === 0 &&
    unusedVars.length === 0 &&
    invalidSyntax.length === 0
  ) {
    return null;
  }

  return (
    <div className={`space-y-2 ${compact ? 'text-sm' : ''}`}>
      {invalidSyntax.length > 0 && (
        <div className="bg-red-50 border border-red-200 text-red-800 rounded-md px-3 py-2">
          <strong className="font-medium">Invalid variable syntax:</strong>{' '}
          {invalidSyntax.map((s) => (
            <code key={s} className="mx-1 bg-red-100 px-1 rounded">
              {s}
            </code>
          ))}
          <span className="block mt-1 text-red-700 text-xs">
            Use {'${Name}'} with letters, digits, or underscore; name must not start with a
            digit.
          </span>
        </div>
      )}
      {undefinedVars.length > 0 && (
        <div className="bg-amber-50 border border-amber-200 text-amber-900 rounded-md px-3 py-2">
          <strong className="font-medium">Undefined variables</strong> (used in prompt but
          not in metadata):{' '}
          {undefinedVars.map((n) => (
            <code key={n} className="mx-1 bg-amber-100 px-1 rounded">
              {`\${${n}}`}
            </code>
          ))}
        </div>
      )}
      {unusedVars.length > 0 && (
        <div className="bg-gray-50 border border-gray-200 text-gray-700 rounded-md px-3 py-2">
          <strong className="font-medium">Unused variables</strong> (defined but not
          referenced with {'${…}'}):{' '}
          {unusedVars.map((n) => (
            <code key={n} className="mx-1 bg-gray-100 px-1 rounded">
              {n}
            </code>
          ))}
        </div>
      )}
    </div>
  );
};

export default VariableValidationAlerts;
